<template>
  <v-list>
    <v-list-item>
      <v-icon small :color="iconColor" @click.stop="$emit('toggleMini')">
        mdi-menu
      </v-icon>
      <v-list-item-title class="pl-2">
        <v-img
          src="https://storage.googleapis.com/static-public-assets/mikmak-logo-white.png"
          max-width="70"
        />
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    mini: Boolean,
  },
  computed: {
    iconColor() {
      return this.mini
        ? '#FFFFFF'
        : '#00BFBD';
    },
  },
};
</script>

<style scoped>
::v-deep .v-icon.v-icon.v-icon--link.theme--dark:after {
  background: none !important;
}
</style>
